import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover.jsx";
import { Button } from "@/components/ui/button.jsx";
import PriceFilter from "@/components/products/PriceFilter.jsx";
import * as reactUse from "react-use";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer.jsx";
import { ChevronDown, ListFilterPlus, SlidersHorizontal } from "lucide-react";

const { useMedia } = reactUse;

export default function ({ onValuesChange }) {
  const isDesktop = useMedia("(width >= 64rem)");

  return (
    <div>
      {isDesktop && (
        <Popover>
          <PopoverTrigger asChild className="group">
            <Button variant="outline" size="xl" className="px-4">
              <ListFilterPlus />
              Цена
              <ChevronDown className="group-data-[state=open]:rotate-180 transition duration-300" />
            </Button>
          </PopoverTrigger>
          <PopoverContent align="start">
            <PriceFilter onValuesChange={onValuesChange} />
          </PopoverContent>
        </Popover>
      )}

      {!isDesktop && (
        <Drawer>
          <DrawerTrigger asChild className="group">
            <Button variant="outline">
              Цена
              <ChevronDown className="group-data-[state=open]:rotate-180 transition duration-300" />
            </Button>
          </DrawerTrigger>
          <DrawerContent className="h-full mx-auto w-full max-w-sm px-4">
            <div className="py-8">
              <PriceFilter onValuesChange={onValuesChange} />
            </div>
          </DrawerContent>
        </Drawer>
      )}
    </div>
  );
}
